'use client';

import { Box, Link } from '@coolblue-development/freddy';
import { HeartOutlined } from '@coolblue-development/icons';
import { useTranslation } from '@i18n/useTranslation';
import { ReactElement } from 'react';

export default function Subheading({
  isLoggedIn,
  logInUrl
}: {
  isLoggedIn: boolean;
  logInUrl?: string;
}): ReactElement {
  const { t, Trans } = useTranslation('webshop.wishlist');

  return (
    <Trans
      t={t}
      i18nKey={!isLoggedIn && logInUrl ? 'logInOrAdd' : 'clickToAdd'}
      components={{
        addIcon: (
          <Box component='span' color='subtle'>
            <HeartOutlined size='medium' />
          </Box>
        ),
        ...(!isLoggedIn && logInUrl && { logIn: <Link href={logInUrl} /> })
      }}
    />
  );
}
